"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCalendarProps = exports.GetCalendarPropsGlobalStyles = void 0;
var classnames_1 = __importDefault(require("classnames"));
var moment_1 = __importDefault(require("moment"));
var react_1 = __importDefault(require("react"));
var styled_components_1 = require("styled-components");
var Typography_1 = require("./Typography");
/**
 * these styles are automatically added to storybook global styles so no need to add them manually on FE.
 * src/styles.tsx
 */
exports.GetCalendarPropsGlobalStyles = styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .whf-ant-calendar-base {\n    padding-left: 32px;\n\n    .ant-picker-week-number {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      position: absolute;\n      margin-left: -28px;\n      width: 24px;\n      height: 24px;\n      cursor: default;\n      pointer-events: none;\n    }\n  }\n"], ["\n  .whf-ant-calendar-base {\n    padding-left: 32px;\n\n    .ant-picker-week-number {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      position: absolute;\n      margin-left: -28px;\n      width: 24px;\n      height: 24px;\n      cursor: default;\n      pointer-events: none;\n    }\n  }\n"])));
var today = moment_1.default();
var getCalendarProps = function (_a) {
    var className = _a.className, dateCellRender = _a.dateCellRender, fullscreen = _a.fullscreen;
    // @ts-expect-error WIP
    var firstDayOfWeek = moment_1.default().localeData()._week.dow;
    return {
        dateFullCellRender: function (current) {
            var _a;
            return (react_1.default.createElement(react_1.default.Fragment, null,
                current.day() === firstDayOfWeek && (react_1.default.createElement("div", { className: "ant-picker-week-number" },
                    react_1.default.createElement(Typography_1.Typography, { style: { color: "#BFBFBF" } }, moment_1.default(current).endOf("week").isoWeek()))),
                react_1.default.createElement("div", { className: classnames_1.default("ant-picker-cell-inner", "ant-picker-calendar-date", (_a = {},
                        _a["ant-picker-calendar-date-today"] = moment_1.default(current).isSame(today, "d"),
                        _a)) },
                    react_1.default.createElement("div", { className: "ant-picker-calendar-date-value" }, moment_1.default(current).date()),
                    react_1.default.createElement("div", { className: "ant-picker-calendar-date-content" }, fullscreen && dateCellRender && dateCellRender(current)))));
        },
        className: classnames_1.default(className, "whf-ant-calendar-base"),
    };
};
exports.getCalendarProps = getCalendarProps;
var templateObject_1;
